<header class="animated fadeInDown" id="navbar">
    <mat-toolbar fxFlex>
        <mat-toolbar-row>
            <a [routerLink]="['/']"><img src="/assets/logo/logo-color.svg"></a>
        </mat-toolbar-row>
    </mat-toolbar>
</header>
